<template>
  <header class="header">
    <div class="in" v-if="!isMobile">
      <router-link to="/">
        <img
          src="http://gxbg.pangodso.com/file/static/logo.png"
          alt=""
          class="logo"
        />
      </router-link>
      <div class="navs">
        <div
          :class="{ nav: true, active: $route.path == item.path }"
          v-for="item in navList"
          :key="item.name"
          @click="navTo(item.path)"
        >
          {{ item.name }}
        </div>
      </div>
    </div>
    <div class="m-in" v-else>
      <div class="sidebar" v-show="sideShow">
        <div class="mask" @click="sideShow = false"></div>
        <div class="sidebar-content">
          <div
            :class="{ nav: true, active: $route.path == item.path }"
            v-for="item in navList"
            :key="item.name"
            @click="navTo(item.path)"
          >
            {{ item.name }}
          </div>
          <div :class="{ nav: true, rotate: linkActive }" @click="showLink">
            集团及旗下公司<i class="el-icon-arrow-right"></i>
          </div>
          <div class="subs" v-show="linkActive">
            <a
              class="nav sub"
              :href="item.hrefUrl"
              target="_blank"
              v-for="item in friendlinkList"
              :key="item.id"
            >
              {{ item.name }}
            </a>
          </div>
        </div>
      </div>
      <div :class="{ menu: true, active: sideShow }" @click="changeSide">
        <span></span>
        <span></span>
        <span></span>
      </div>
      <router-link to="/">
        <img
          src="http://gxbg.pangodso.com/file/static/logo.png"
          alt=""
          class="logo"
        />
      </router-link>
    </div>
  </header>
</template>

<script>
import { Store } from "@/store/index.js";
import { mapState } from "pinia";

export default {
  data() {
    return {
      navList: [
        {
          name: "首页",
          path: "/",
        },
        {
          name: "服务介绍",
          path: "/business/Search",
        },
        {
          name: "企业介绍",
          path: "/intro",
        },
        {
          name: "优秀案例",
          path: "/case",
        },
        {
          name: "联系我们",
          path: "/contact",
        },
        {
          name: "加入我们",
          path: "/join",
        },
      ],
      sideShow: false,
      linkActive: false,
    };
  },
  computed: {
    ...mapState(Store, ["isMobile", "friendlinkList"]),
  },
  mounted() {},
  methods: {
    changeSide() {
      this.sideShow = !this.sideShow;
    },
    navTo(path) {
      this.sideShow = false;
      window.scrollTo({ top: 0 });
      this.$router.push(path);
    },
    showLink() {
      this.linkActive = !this.linkActive;
    },
  },
};
</script>

<style lang="scss" scoped>
@keyframes translateXIn {
  from {
    transform: translateX(-30vw);
  }
  to {
    transform: translateX(0);
  }
}
.header {
  background-color: #fff;
  box-shadow: 0 0 5px #ccc;
  position: sticky;
  top: 0;
  z-index: 999;
}
.in {
  width: 1200px;
  height: 70px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .logo {
    height: 45px;
  }
}
.navs {
  display: flex;
  font-weight: bold;

  .nav {
    font-size: 14px;
    padding: 20px 10px;
    color: #666;
    cursor: pointer;

    &:hover {
      color: $theme;
    }
    &:not(:first-child) {
      margin-left: 30px;
    }
  }
  .active {
    color: $theme;
  }
}

.m-in {
  height: 55px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;

  .sidebar {
    width: 100vw;
    height: 100vh;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 1999;

    .mask {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      background-color: rgba($color: #000000, $alpha: 0.7);
    }
    .sidebar-content {
      width: 30vw;
      height: 100vh;
      position: absolute;
      left: 0;
      top: 0;
      background-color: #fff;
      color: #000;
      padding: 55px 0;
      text-align: center;
      animation: translateXIn 0.5s;
      overflow: auto;

      a.nav {
        display: block;
      }
      .nav {
        padding: 10px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        position: relative;

        i {
          position: absolute;
          right: 5px;
          top: 50%;
          transform: translateY(-50%);
          transition: transform 0.5s;
        }
      }
      .rotate i {
        transform: translateY(-50%) rotate(90deg);
      }
      .sub {
        color: #666;
        font-size: 14px;
      }
      .active {
        color: $theme;
      }
    }
  }
  .menu {
    width: 24px;
    height: 20px;
    position: relative;
    z-index: 2999;

    span {
      width: 24px;
      height: 2px;
      display: block;
      background-color: $theme;
      position: relative;
      transition: 0.3s;

      &:not(:last-child) {
        margin-bottom: 7px;
      }
      &:nth-child(2) {
        width: 10px;
      }
      &:nth-child(3) {
        width: 15px;
      }
    }
  }
  .active span {
    &:not(:last-child) {
      margin-bottom: 0;
    }
    &:nth-child(1) {
      transform: rotate(45deg) translateY(1px);
    }
    &:nth-child(2) {
      width: 24px;
      transform: rotate(-45deg) translateY(-1px);
    }
    &:nth-child(3) {
      display: none;
    }
  }
  a {
    height: 60%;
  }
  .logo {
    height: 100%;
  }
}

@media (max-width: 1400px) {
  .in {
    width: 1000px;
  }
}
</style>
